import type { ComponentChildren } from 'preact';

interface HeroProps {
  // Omitted where the heading names the page by itself.
  eyebrow?: string;
  // A string, or a rendered rich message when the heading carries inline markup.
  title: ComponentChildren;
  lede: string;
  children?: ComponentChildren;
}

export function Hero({ eyebrow, title, lede, children }: HeroProps) {
  return (
    <section className="mkt-hero">
      <div className="mkt-container-narrow">
        {eyebrow && <span className="mkt-eyebrow">{eyebrow}</span>}
        <h1 className="mkt-h1 wide">{title}</h1>
        <p className="mkt-lede">{lede}</p>
        {children && <div className="mkt-cta-row">{children}</div>}
      </div>
    </section>
  );
}
